console.log('_main.js ...');

  //$('.AKonepagenav:first').akonepagenav('div.view-pageslide', 'article.node', 'div.field.title');
